import {
  isLargeOperation,
  type LargeOperation,
} from '@festina/configuration-general-types/configuration'
import { isParameterValueCreateOperation } from '@festina/life-general-types/life'
import { useFetchLargeOperations } from '@festina-life/api'
import { notEmpty, type Optional } from '@festina-life/core'
import { useMemo } from 'react'

import { useNavigationParams } from '../../system/useNavigationParams'
import type {
  ParameterValueEntityOperation,
  ParameterValueOperation,
} from '../parameterOperations/types'
import type { OperationWithSourceInfo } from '../types'
import { mapLargeOperationsToResolvedValueOperations } from './helpers'

export const useResolvedLargeParameterValues = (
  fromOperations: Optional<OperationWithSourceInfo<ParameterValueOperation>[]>,
): OperationWithSourceInfo<ParameterValueEntityOperation>[] => {
  const { server } = useNavigationParams()

  const largeValuesForId = fromOperations?.filter(
    (
      editableOperation,
    ): editableOperation is OperationWithSourceInfo<LargeOperation> =>
      isLargeOperation(editableOperation.internalOperation),
  )

  const fetchLargeOperationIds = (largeValuesForId ?? [])
    .map((editableOperation) => editableOperation.internalOperation._id)
    .filter(notEmpty)

  const { data: resolvedLargeOperations } = useFetchLargeOperations({
    operationIds: fetchLargeOperationIds,
    server,
    enabled: !!fetchLargeOperationIds.length,
    validate: isParameterValueCreateOperation,
  })

  return useMemo(
    () =>
      mapLargeOperationsToResolvedValueOperations({
        values: fromOperations ?? [],
        largeOperations: resolvedLargeOperations ?? [],
      }),
    [fromOperations, resolvedLargeOperations],
  )
}
